import { gql, useSubscription } from '@apollo/client';
import { useContext, useEffect } from 'react';
import { CompanyContext } from '../../context/CompanyContext';
import React from 'react';
import { forNotification } from '../Common/forNotification';
import { useAppDispatch } from '../../ui/pages/store';
import { CompanyConnectionFragments } from '../../graphql/companyConnection.graphql';
import { CompanyConnection } from '../../types/companyConnection/companyConnection';
import { CompanyConnectionContext } from '../../context/CompanyConnectionContext';

const companyConnectionSubscription = gql`
  subscription companyConnectionNotification($companyId: String!) {
    companyConnectionNotification(companyId: $companyId) {
      companyId
      entities {
        ...CompanyConnection
      }
      topic
      date
    }
  }
  ${CompanyConnectionFragments.companyConnection}
`;

export class CompanyConnectionNotificationResponse extends forNotification<CompanyConnection>(
  'companyConnectionNotification',
) {}

export default function CompanyConnectionNotification({}) {
  const { currentCompany } = useContext(CompanyContext);
  const { companyConnections, setCompanyConnections } = useContext(CompanyConnectionContext);
  const dispatch = useAppDispatch();

  if (!currentCompany) return null;

  const { data: companyConnectionNotification } = useSubscription<CompanyConnectionNotificationResponse>(
    companyConnectionSubscription,
    {
      variables: { companyId: currentCompany.id },
    },
  );

  const handleCompanyConnectionNotification = (notification?: CompanyConnectionNotificationResponse) => {
    if (!notification?.companyConnectionNotification) return;
    const companyConnectionNotification = notification.companyConnectionNotification;

    switch (companyConnectionNotification.topic) {
      case 'CREATE':
      case 'UPDATE':
        companyConnectionNotification.entities.forEach(cc => companyConnections.set(cc.id, cc));
        setCompanyConnections(new Map(companyConnections));
        break;
      case 'DELETE':
        companyConnectionNotification.entities.forEach(cc => companyConnections.delete(cc.id));
        setCompanyConnections(new Map(companyConnections));
        break;
    }
  };

  useEffect(() => {
    handleCompanyConnectionNotification(companyConnectionNotification);
  }, [companyConnectionNotification]);

  return <></>;
}
